import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>
              HK<span>Design</span>
            </h3>
            <p>
              Profesyonel web tasarım ve sesli yazıya çeviri hizmetleri.
              İşinizi dijital dünyada öne çıkarıyoruz.
            </p>
          </div>

          <div className="footer-links">
            <h4>Sayfalar</h4>
            <Link to="/">Ana Sayfa</Link>
            <Link to="/hizmetler">Hizmetlerim</Link>
            <Link to="/portfoy">Portföy</Link>
            <Link to="/hakkimda">Hakkımda</Link>
            <Link to="/iletisim">İletişim</Link>
          </div>

          <div className="footer-links">
            <h4>Hizmetler</h4>
            <Link to="/hizmetler">Web Tasarım</Link>
            <Link to="/hizmetler">Sesli Yazıya Çeviri</Link>
            <Link to="/hizmetler">Canlı Altyazı</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 HK Design. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
